var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoNotDisturb = function SvgDoNotDisturb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_12_settings_status_popup",
    transform: "translate(-48.000000, -554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(24.000000, 475.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(24.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F28CA6",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1428571,8.14285714 L9.85714286,8.14285714 L9.85714286,3.85714286 C9.85714286,3.384 9.47314286,3 9,3 C8.52685714,3 8.14285714,3.384 8.14285714,3.85714286 L8.14285714,8.14285714 L3.85714286,8.14285714 C3.384,8.14285714 3,8.52685714 3,9 C3,9.47314286 3.384,9.85714286 3.85714286,9.85714286 L8.14285714,9.85714286 L8.14285714,14.1428571 C8.14285714,14.616 8.52685714,15 9,15 C9.47314286,15 9.85714286,14.616 9.85714286,14.1428571 L9.85714286,9.85714286 L14.1428571,9.85714286 C14.616,9.85714286 15,9.47314286 15,9 C15,8.52685714 14.616,8.14285714 14.1428571,8.14285714",
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(9.000000, 9.000000) rotate(-45.000000) translate(-9.000000, -9.000000) "
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoNotDisturb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/do_not_disturb.0c1913f4.svg";
export { ForwardRef as ReactComponent };